import { useQuery } from '@tanstack/react-query';
import { getBookCharacters } from '../api/characters';
import type { CharactersResponse } from '../api/characters';

interface UseBookCharactersOptions {
  enabled?: boolean;
}

export const useBookCharacters = (
  bookId: number | null,
  options: UseBookCharactersOptions = {}
) => {
  return useQuery<CharactersResponse, Error>({
    queryKey: ['book-characters', bookId],
    queryFn: () => getBookCharacters(bookId!),
    enabled: !!bookId && (options.enabled !== false),
    ...options,
  });
};
